import React from 'react';
import {
  InfoBannerContainer,
  InfoBannerItem,
  InfoBannerTitle,
  InfoBannerNumber,
  InfoBannerText
} from './styles';


/**
 * returns the number of available subscriptions
 * 
 * @param params.data - Array with objects containing the subscriptions and their amounts of type { number, text }
 * @param params.title - title that will be visible in the component
 * @param params.itemWidth - minimum width of the card that contains the subscription information
 * @param params.lineBetweenTitle - Boolean to validate if there is a line between the title and the subscriptions
 * @returns returns the data as follows 'title | number subscription |'
 */
export default ({
  data,
  title,
  itemWidth,
  lineBetweenTitle = true,
}: {
  data: Array<any>,
  title?: String,
  itemWidth?: string,
  lineBetweenTitle?: boolean
}) => (
  <InfoBannerContainer>
    {title && <InfoBannerTitle lineBetweenTitle={lineBetweenTitle}>
      {title}
    </InfoBannerTitle>
    }
    {data.map((el, idx) => (
      <InfoBannerItem key={idx} width={itemWidth} lineBetweenTitle={lineBetweenTitle}>
        <InfoBannerNumber>{el.number}</InfoBannerNumber>
        <InfoBannerText>{el.text}</InfoBannerText>
      </InfoBannerItem>
    ))}
  </InfoBannerContainer>
);
